import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { formatTime } from "@clipboard-health/date-time";
import { getComputedArrivalForWorker } from "@src/appV2/Shifts/utils/getComputedArrival";

function ShiftDescription({ shift, isCancel }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [state, setState] = useState<any>({});
  useEffect(() => {
    const startTime = moment(shift.start);
    const endTime = moment(shift.end);
    const startAndEndInDifferentTimezone = startTime.zoneAbbr() !== endTime.zoneAbbr();
    const calendar = startTime.calendar(null, { sameElse: "ddd MMM Do YYYY" });
    const isSameDay = startTime.isSame(endTime, "day");
    const timeFormat = "hh:mm a";
    const rangeText = `${startTime.format(`${timeFormat} z`)} until ${endTime.format(
      `${startAndEndInDifferentTimezone ? `${timeFormat} z,` : timeFormat}`
    )}`;
    const computedArrival = getComputedArrivalForWorker({
      computedArrivals: shift.computedArrivals,
      agentId: shift.agentId,
      bookedAt: shift.bookedAt,
      start: shift.start,
    });

    setState({
      calendar,
      rangeText,
      duration: `${shift.time?.toFixed(2)} hrs`,
      nextDay: isSameDay ? "" : "next day",
      isHoliday: shift.isHolidayShift,
      holidayName: shift.holidayName,
      startAndEndInDifferentTimezone,
      computedArrival,
    });
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shift]);

  return (
    <div data-testid="shift-item-admin-shift-description">
      {state.calendar}
      {isCancel && shift.isBillable && "(Late Cancel: $" + shift.charge * shift.time + " Fee)"}
      <i>
        {" "}
        ({state.duration}, {state.rangeText}
        {state.nextDay && ` ${state.nextDay}`}
        {state.startAndEndInDifferentTimezone && " with a clock change for Daylight Saving Time"})
      </i>
      <br />
      {!isCancel && shift.extendBookabilityTo && shift.extendBookabilityTo > shift.start && (
        <p>
          Bookable until{" "}
          {formatTime(shift.extendBookabilityTo, {
            timeZone: shift.facility?.tmz,
          })}
        </p>
      )}
      {state.computedArrival && (
        <p>
          <strong>
            Target arrival time:{" "}
            {formatTime(state.computedArrival.targetArrivalTime, {
              timeZone: shift.facility?.tmz,
            })}
          </strong>
        </p>
      )}
      {state.isHoliday && (
        <h4>It is {state.holidayName || "a holiday"}. Holiday charges will apply.</h4>
      )}
    </div>
  );
}

export { ShiftDescription };
